'use strict';
/**
 * @author Maxim Seredkin
 */
export default function() {
    return {
        restrict: 'A',
        template: require('../view/staff-table-row.html'),
        transclude: true,
        scope: {
            staff: '=myValue',
            mySize: '=?mySize',
            myFilters: '=?myFilters',
            myRequired: '=?myRequired',
            myDef: '=?myDef',
            myReadonly: '=?myReadonly',
            myName: '=?myName',
            edit: '=edit',
        },
        controller: ['$scope', 'StaffService',
                     function($scope, StaffService) {
                         $scope.select = select;
                         $scope.clear = clear;

                         // region Function

                         function select() {
                             StaffService.select($scope.staff, $scope.myFilters, $scope.myDef).result.then((data) => $scope.staff = data);
                         }

                         function clear() {
                             $scope.staff = null;
                         }

                         // endregion
                     }],
    };
}
